import auth from "@/services/ExerciseInitAuth";

const list = query =>
  auth.get(`${process.env.VUE_APP_EXERCISE_API}nu_exams/users_admin/`, {
    params: query
  });

const remove = id =>
  auth.delete(`${process.env.VUE_APP_EXERCISE_API}nu_exams/users_admin/${id}`);

const changePassword = (id, password) =>
  auth.put(`${process.env.VUE_APP_EXERCISE_API}nu_exams/users_admin/${id}/change_password/`, {password});

const loadUserExams = query =>
  auth.get(`${process.env.VUE_APP_EXERCISE_API}admin/training_exams/`, {
    params: query
  });

const loadUserCbrExams = query =>
  auth.get(`${process.env.VUE_APP_EXERCISE_API}admin/cbr_exams/`, {
    params: query
  });

export default {
  list,
  remove,
  loadUserExams,
  loadUserCbrExams,
  changePassword
};
